/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GuidReferenceReadModel
 */
export interface GuidReferenceReadModel {
    /**
     * 
     * @type {string}
     * @memberof GuidReferenceReadModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GuidReferenceReadModel
     */
    displayName: string;
}

/**
 * Check if a given object implements the GuidReferenceReadModel interface.
 */
export function instanceOfGuidReferenceReadModel(value: object): value is GuidReferenceReadModel {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function GuidReferenceReadModelFromJSON(json: any): GuidReferenceReadModel {
    return GuidReferenceReadModelFromJSONTyped(json, false);
}

export function GuidReferenceReadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidReferenceReadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
    };
}

export function GuidReferenceReadModelToJSON(json: any): GuidReferenceReadModel {
    return GuidReferenceReadModelToJSONTyped(json, false);
}

export function GuidReferenceReadModelToJSONTyped(value?: GuidReferenceReadModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
    };
}

